module.exports = __webpack_public_path__ + "static/media/siddharth-amaravati-trip-13.f38db040.png";